import { decodeAny } from "./decodeAny";
import { decodeNumber } from "./decodeNumber";
import { decodeString } from "./decodeString";
import type { EncodableRecord } from "./types";

export function decodeRecord(
  data: Uint8Array,
  offset = 0,
): [EncodableRecord, number] {
  const [itemsCount, itemsCountBytes] = decodeNumber(data, offset + 1);
  const result: EncodableRecord = {};
  let cursor = offset + 1 + itemsCountBytes;

  for (let i = 0; i < itemsCount; i++) {
    // key (string)
    const [key, keyConsumed] = decodeString(data, cursor);
    cursor += keyConsumed;

    // value (string | array | record)
    const [value, valueConsumed] = decodeAny(data, cursor);
    cursor += valueConsumed;

    result[key] = value;
  }

  return [result, cursor - offset];
}
